import { render } from "./SearchPage.vue?vue&type=template&id=4f097a16"
import script from "./SearchPage.vue?vue&type=script&lang=js"
export * from "./SearchPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__